import React from 'react';
import {TypicalMessage, TypicalMessageProps} from './TypicalMessage';

export function OrderCreated(props: TypicalMessageProps) {
    const details = props.model.message_details as any;

    return <TypicalMessage
            model={props.model}
            options={props.options}
            choice={1 + +!!details['status_id']}
            messageKeysWithStatusId={['status_id']}
    />;
}
